import { configureStore } from "@reduxjs/toolkit";
import CampaignReducer from "./features/websocket/webCampaignSlice";


export const store = configureStore({
    reducer:{
        campaign:CampaignReducer
    }
})